export default "__VITE_ASSET__BpjyP550__";